/* Quick View - update cart after adding to cart in Quick View */
document.addEventListener('qview-addedtocart', function() {
  document.documentElement.dispatchEvent(new CustomEvent('product:added', {
    bubbles: true,
    detail: {
      quantity: 1,
    },
  }));
});